
import {
  defineComponent, onBeforeMount, reactive, ref,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { ICadastro } from '@/models/Entidades/ICadastro';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoCadastro from '@/servicos/ServicoCadastro';
import { IResposta } from '@/core/models/IResposta';
import Card from '@/core/components/UI/Card.vue';
import CampoCpf from '@/core/components/UI/CampoCpf.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarSimNao from '@/core/components/UI/SelecionarSimNao.vue';
import storeApp from '@/store/storeApp';
import { ETipoRelacaoCadastro } from '@/models/Enumeradores/ETipoRelacaoCadastro';
import CampoTelefone from '@/core/components/UI/CampoTelefone.vue';
import CampoEmail from '@/core/components/UI/CampoEmail.vue';
import { ETipoDocumento } from '@/models/Enumeradores/ETipoDocumento';
import ComboTipoDocumento from '@/components/ComboTipoDocumento.vue';
import CampoCnpj from '@/core/components/UI/CampoCnpj.vue';
import { IEndereco } from '@/models/Entidades/IEndereco';
import { ETipoVinculo } from '@/models/Enumeradores/ETipoVinculo';
import ServicoUtilitario from '@/servicos/ServicoUtilitario';
import CampoCep from '@/core/components/UI/CampoCep.vue';
import ComboCidade from '@/components/ComboCidade.vue';

export default defineComponent({
  name: 'CadastroCadastro',
  components: {
    ComunicacaoApi,
    Card,
    ComboTipoDocumento,
    CampoCpf,
    CampoCnpj,
    CampoTelefone,
    CampoEmail,
    SelecionarSimNao,
    CampoCep,
    ComboCidade,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoCadastro = new ServicoCadastro();
    const servicoUtilitario = new ServicoUtilitario();
    const consultandoDocumento = ref<boolean>(false);
    const state = reactive({
      pessoa: {} as ICadastro,
      cpfCnpj: '',
      numeroDocumentoHistorico: '',
      cep: '',
    });

    function limparDados() {
      state.numeroDocumentoHistorico = '';
      state.cep = '';
      state.pessoa = {} as ICadastro;
      state.pessoa.codigo = 0;
      state.pessoa.tipo = ETipoRelacaoCadastro.Pessoa;
      state.pessoa.tipoDocumento = ETipoDocumento.CPF;
      state.pessoa.status = true;
      state.pessoa.enderecos = [];

      const endereco:IEndereco = {} as IEndereco;
      endereco.codigo = 0;
      endereco.codigoParceiro = 0;
      endereco.tipoVinculo = ETipoVinculo.Cadastro;
      endereco.codigoVinculo = 0;
      state.pessoa.enderecos.push(endereco);
      state.cpfCnpj = '';
    }

    async function obterCadastro(codigo:number) {
      appBase.carregando = true;
      state.pessoa = await servicoCadastro.obter(codigo);
      state.cpfCnpj = state.pessoa.numeroDocumento;

      if (!UtilitarioGeral.validaLista(state.pessoa.enderecos)) {
        const endereco:IEndereco = {} as IEndereco;
        endereco.codigo = 0;
        endereco.codigoParceiro = 0;
        endereco.tipoVinculo = ETipoVinculo.Cadastro;
        endereco.codigoVinculo = 0;
        state.pessoa.enderecos.push(endereco);
      }
      appBase.carregando = false;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigopessoa = obterCodigoRota();
      if (codigopessoa > 0) {
        await obterCadastro(codigopessoa);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;

      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da pessoa.');
      if (state.pessoa.codigo === 0) {
        appBase.resposta = await servicoCadastro.incluir(state.pessoa);
      } else {
        appBase.resposta = await servicoCadastro.atualizar(state.pessoa);
      }

      apresentarRespostaRedirecionamento('Pessoas');
    }

    async function consultaDocumento() {
      if (state.pessoa.tipoDocumento === ETipoDocumento.CNPJ) {
        if (UtilitarioGeral.valorValido(state.pessoa.numeroDocumento) && UtilitarioGeral.validaValorComLimiteCaracteres(state.pessoa.numeroDocumento, 14)) {
          if (state.pessoa.numeroDocumento !== state.numeroDocumentoHistorico) {
            consultandoDocumento.value = true;
            const retornoConsultaCnpj = await servicoUtilitario.consultaCnpj(state.pessoa.numeroDocumento);
            consultandoDocumento.value = false;
            if (retornoConsultaCnpj !== undefined) {
              if (UtilitarioGeral.valorValido(retornoConsultaCnpj.razaoSocial)) {
                state.pessoa.nome = retornoConsultaCnpj.razaoSocial;
                // state.pessoa.nomeFantasia = retornoConsultaCnpj.nomeFantasia;
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.contato.telefonePrincipal)) {
                  state.pessoa.telefone = retornoConsultaCnpj.contato.telefonePrincipal;
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.contato.email)) {
                  state.pessoa.email = retornoConsultaCnpj.contato.email;
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.endereco.cep)) {
                  state.pessoa.enderecos[0].cep = retornoConsultaCnpj.endereco.cep;
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.endereco.logadouro)) {
                  state.pessoa.enderecos[0].enderecoCompleto = retornoConsultaCnpj.endereco.logadouro;
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.endereco.numero)) {
                  if (retornoConsultaCnpj.endereco.numero !== 'S/N' && retornoConsultaCnpj.endereco.numero !== 'SN') {
                    state.pessoa.enderecos[0].numero = retornoConsultaCnpj.endereco.numero;
                  }
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.endereco.bairro)) {
                  state.pessoa.enderecos[0].bairro = retornoConsultaCnpj.endereco.bairro;
                }
                if (UtilitarioGeral.valorValido(retornoConsultaCnpj.endereco.complemento)) {
                  state.pessoa.enderecos[0].complemento = retornoConsultaCnpj.endereco.complemento;
                }

                if (UtilitarioGeral.validaCodigo(retornoConsultaCnpj.endereco.codigoCidade)) {
                  state.pessoa.enderecos[0].codigoCidade = retornoConsultaCnpj.endereco.codigoCidade;
                }
                state.numeroDocumentoHistorico = state.pessoa.numeroDocumento;
              }
            }
          }
        }
      }
    }

    async function consultaCep() {
      if (UtilitarioGeral.validaLista(state.pessoa.enderecos)) {
        if (UtilitarioGeral.valorValido(state.pessoa.enderecos[0].cep) && UtilitarioGeral.validaValorComLimiteCaracteres(state.pessoa.enderecos[0].cep, 8)) {
          if (state.pessoa.enderecos[0].cep !== state.cep) {
            const retornoConsultaCep = await servicoUtilitario.consultaCep(state.pessoa.enderecos[0].cep);
            if (retornoConsultaCep !== undefined) {
              state.pessoa.enderecos[0].enderecoCompleto = retornoConsultaCep.logradouro;
              state.pessoa.enderecos[0].complemento = retornoConsultaCep.complemento;
              state.pessoa.enderecos[0].bairro = retornoConsultaCep.bairro;
              state.pessoa.enderecos[0].codigoCidade = retornoConsultaCep.codigoCidade;
              state.cep = state.pessoa.enderecos[0].cep;
            }
          }
        }
      }
    }

    return {
      appBase,
      storeApp,
      state,
      salvar,
      UtilitarioGeral,
      ETipoDocumento,
      consultaDocumento,
      consultaCep,
    };
  },
});
